<template>
  <svg height="160" width="160" viewBox="0 0 160 160" class="donut-chart">
    <g v-for="(value, index) in sortedValues" :key="index">
      <circle
        :cx="cx"
        :cy="cy"
        :r="radius"
        :stroke="colors[index]"
        :stroke-width="strokeWidth"
        :stroke-dasharray="adjustedCircumference"
        :stroke-dashoffset="calculateStrokeDashOffset(value, circumference)"
        fill="transparent"
        :transform="returnCircleTransformValue(index)"
      />
      <text
        v-if="segmentBigEnough(value)"
        text-anchor="middle"
        dy="3px"
        :x="chartData[index].textX"
        :y="chartData[index].textY"
      >
        {{ percentageString(value) }}
      </text>
    </g>
  </svg>
</template>
<script>
export default {
  props: ['initialValues'],
  data() {
    return {
      angleOffset: -90,
      chartData: [],
      colors: ['#CC00FF', '#a300cc', '#E53E3E'],
      cx: 80,
      cy: 80,
      radius: 60,
      sortedValues: [],
      strokeWidth: 40,
    }
  },

  computed: {
    // adjust the circumference to add small white gaps
    adjustedCircumference: function () {
      return this.circumference - 2
    },
    circumference: function () {
      return 2 * Math.PI * this.radius
    },
    dataTotal: function () {
      return this.sortedValues.reduce((acc, val) => acc + val)
    },
  },

  mounted: function () {
    this.sortInitialValues()
    this.calculateChartData()
  },

  methods: {
    sortInitialValues: function () {
      this.sortedValues = this.initialValues
    },
    calculateChartData: function () {
      this.sortedValues.forEach((dataVal, index) => {
        const { x, y } = this.calculateTextCoords(dataVal, this.angleOffset)
        // start at -90deg so that the largest segment is perpendicular to top
        const data = {
          degrees: this.angleOffset,
          textX: x,
          textY: y,
        }
        this.chartData.push(data)
        this.angleOffset = this.dataPercentage(dataVal) * 360 + this.angleOffset
      })
      return 0
    },
    calculateStrokeDashOffset: function (dataVal, circumference) {
      const strokeDiff = this.dataPercentage(dataVal) * circumference
      return circumference - strokeDiff
    },
    calculateTextCoords: function (dataVal, angleOffset) {
      // t must be radians
      // x(t) = r cos(t) + j
      // y(t) = r sin(t) + j

      const angle = (this.dataPercentage(dataVal) * 360) / 2 + angleOffset
      const radians = this.degreesToRadians(angle)

      const textCoords = {
        x: this.radius * Math.cos(radians) + this.cx,
        y: this.radius * Math.sin(radians) + this.cy,
      }
      return textCoords
    },
    degreesToRadians: function (angle) {
      return angle * (Math.PI / 180)
    },
    dataPercentage: function (dataVal) {
      return dataVal / this.dataTotal
    },
    percentageString(dataVal) {
      return `${Math.round(this.dataPercentage(dataVal) * 100)}%`
    },
    returnCircleTransformValue: function (index) {
      return `rotate(${this.chartData[index].degrees}, ${this.cx}, ${this.cy})`
    },
    segmentBigEnough(dataVal) {
      return Math.round(this.dataPercentage(dataVal) * 100) > 5
    },
  },
}
</script>
<style scoped lang="postcss">
text {
  fill: white;
  @apply font-main text-sm;
}
</style>
